import React from 'react';

import RecorrerListarTarjetas from './ListarTarjetas/RecorrerListarTarjetas';

const TablaTarjetas = () => {
    return <RecorrerListarTarjetas />;
};

export default TablaTarjetas;
